import { render, staticRenderFns } from "./StartForm12.vue?vue&type=template&id=224dc482&scoped=true"
import script from "./StartForm12.vue?vue&type=script&lang=ts"
export * from "./StartForm12.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224dc482",
  null
  
)

export default component.exports